import { Chip } from '@mui/material'
import { MRT_ColumnDef } from 'material-react-table'

import { TipoArticuloProps } from '../../../../interfaces/tipoArticulo'
import { genReplaceEmpty } from '../../../../utils/helper'

export const tipoArticuloColumns: MRT_ColumnDef<TipoArticuloProps>[] = [
  {
    accessorKey: 'orden',
    header: 'Orden',
    enableColumnFilter: false,
    enableSorting: true,
    size: 80,
    muiTableBodyCellProps: {
      sx: {
        justifyContent: 'center',
      },
    },
    Cell: ({ cell }) => (
      <Chip
        label={cell.getValue<number>()}
        variant="outlined"
        size="small"
        color="primary"
        sx={{ color: (theme) => theme.palette.text.primary, fontWeight: 'bold' }}
      />
    ),
  },
  {
    accessorKey: 'codigo',
    header: 'Código',
    size: 100,
  },
  {
    accessorKey: 'descripcion',
    header: 'Descripción',
    enableSorting: false,
    size: 150,
  },
  {
    accessorKey: 'notas',
    header: 'Notas Rápidas',
    enableColumnFilter: false,
    Cell: ({ cell }) => {
      return genReplaceEmpty(cell.getValue<string[]>(), []).map((item: string, index: number) => {
        return <Chip key={index} label={item} size="small" sx={{ mr: 0.5 }} />
      })
    },
  },
]
